import { trendingVideos } from '@/mocks/home';
import VideoCard from '@/components/feature/VideoCard';

export default function TrendingVideos() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">全网最受欢迎的视频内容</p>
          </div>
          <div className="hidden sm:flex items-center gap-1">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
              <i className="ri-fire-line"></i>
              实时热榜
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trendingVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}